const OPENED_CLASSNAME = "move-left"

const offCanvasWrapSelector = "[data-offcanvas]"
const offCanasMenuSelector = "[data-offcanvas-menu]"
const offCanvasInnerWrapSelector = "[data-offcanvas-innerwrap]"
const offCanvasToggleSelector = ".js-offcanvas-toggle"

function asideMenu() {
  const buttons = Array.from(document.querySelectorAll(offCanvasToggleSelector))
  const offCanvasMenu = document.querySelector(offCanasMenuSelector)
  const offCanvasWrap = document.querySelector(offCanvasWrapSelector)
  const offCanvasInnerWrap = document.querySelector(offCanvasInnerWrapSelector)

  function innerWrapListener(event) {
    if (offCanvasMenu.contains(event.target)) return

    offCanvasWrap.classList.remove(OPENED_CLASSNAME)
    offCanvasInnerWrap.removeEventListener("click", innerWrapListener)
  }

  buttons.forEach((button) => {
    button.addEventListener("click", (event) => {
      event.preventDefault()

      offCanvasWrap.classList.toggle(OPENED_CLASSNAME)

      setTimeout(() => {
        if (offCanvasWrap.classList.contains(OPENED_CLASSNAME)) {
          offCanvasInnerWrap.addEventListener("click", innerWrapListener)
        } else {
          offCanvasInnerWrap.removeEventListener("click", innerWrapListener)
        }
      }, 0)
    })
  })
}

export default asideMenu
